import { motion } from "framer-motion";

export const SectionLabel = ({ children, testid }) => (
  <div className="flex items-center gap-3 mb-6" data-testid={testid}>
    <span className="h-px w-10 bg-brand-teal" />
    <span className="font-sans text-xs tracking-[0.28em] uppercase text-brand-teal">{children}</span>
  </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headings
export const MaskedLines = ({ lines, className = "", delay = 0, testid }) => (
  <div data-testid={testid}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${className}`}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);
